<template>
  <div class="ud-body">
    <a-card :bordered="true">
      <a-form ref="form" :rules="rules" :label-col="labelCol" :model="form" :wrapper-col="wrapperCol" class="form">
        <a-row>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="手机号" name="username">
              <a-input placeholder="请输入手机号" v-model:value="form.username"  allow-clear></a-input> </a-form-item></a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="真实姓名" name="realName">
              <a-input placeholder="请输入真实姓名" v-model:value="form.realName" allow-clear></a-input> </a-form-item></a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="电池编号" name="batteryCode">
              <a-input placeholder="请输入电池编号" v-model:value="form.batteryCode" allow-clear></a-input> </a-form-item></a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="订单编号" name="orderNumber">
              <a-input placeholder="请输入订单编号" v-model:value="form.orderNumber" allow-clear></a-input> </a-form-item></a-col>
        </a-row>
        <a-row v-if="expand">
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="所属运营商" name="operatorId">
              <a-select v-model:value="form.operatorId" placeholder="请选择所属运营商" @change="handleChangeOperator" allow-clear>
                <a-select-option v-for="item in operatorList" :key="item.operatorId" :value="item.operatorId">
                  {{ item.operatorName }}
                </a-select-option>
              </a-select>
            </a-form-item></a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="所属租赁点" name="pointId">
              <a-select v-model:value="form.pointId" placeholder="请选择所属租赁点" allow-clear>
                <a-select-option v-for="item in pointList" :key="item.pointId" :value="item.pointId">
                  {{ item.pointName }}
                </a-select-option>
              </a-select>
            </a-form-item></a-col>
          <a-col :lg="6" :md="12" :sm="24" :xs="24">
            <a-form-item label="放电开关" name="electricSwitch">
              <a-select v-model:value="form.electricSwitch" placeholder="请选择放电开关" allow-clear>
                <a-select-option v-for="(item, index) in dischargeList" :key="index" :value="item.dictDataCode">{{
                  item.dictDataName }}</a-select-option>
              </a-select></a-form-item></a-col>
        </a-row>
        <a-row type="flex" justify="end">
          <a-space class="btn-wrap">
            <a-button type="primary" @click="reload"><i class="iconfont icon-zaitu"></i>查询</a-button>
            <a-button @click="reset">
              <i class="iconfont icon-mimazhongzhi"></i>重置</a-button>
            <span v-if="!expand" @click="expandForm" style="color: #1890ff; cursor: pointer">
              展开<i class="iconfont icon-xiangxiajiantou"></i>
            </span>
            <span v-else @click="expandForm" style="color: #1890ff; cursor: pointer">
              收起<i class="iconfont icon-xiangshang_jiantou"></i>
            </span>
          </a-space>
        </a-row>
      </a-form>
    </a-card>
    <a-card :bordered="true" class="table">
      <div>
        <ud-pro-table ref="table" :rowKey="(record) => record.orderId" :columns="columns" :datasource="datasource"
          @change="handleChange" :scroll="{ x: 'max-content' }">
          <template #toolbar>            
          </template>
          <template #orderCode="{ record }">
            <div style="color: #409eff; text-decoration: underline">
              {{ record.orderCode }}
            </div>
          </template>
          <template #batteryCode="{ record }">
            <div style="color: #409eff; text-decoration: underline">
              {{ record.batteryCode }}
            </div>
          </template>
          <template #point="{ record }">
            <div style="color: #409eff; text-decoration: underline">
              {{ record.point }}
            </div>
          </template>
          <template #customTitle>
            <div>
              所属运营商
              <i class="iconfont icon-bukejian" style="cursor: pointer" v-if="!isShowOperator"
                @click="isShowOperator = true"></i>
              <i class="iconfont icon-kejian" style="cursor: pointer" v-else @click="isShowOperator = false"></i>
            </div>
          </template>
          <template #operatorCustom="{ record }">
            <div v-if="!isShowOperator && record.operatorName">
              {{
                record.operatorName.substring(0, 1) +
                new Array(record.operatorName.length).join('*')
              }}
            </div>
            <div v-else>
              {{ record.operatorName }}
            </div>
          </template>
        </ud-pro-table>
      </div>
    </a-card>

    <!-- <operation-detail
      v-model:visible="showDetail"
      :data="current || {}"
    ></operation-detail>
    <operation-edit v-model:visible="showEdit" :data="current" @done="reload" /> -->
  </div>
</template>

<script>
// import operationDetail from './operation-detail.vue'
// import operationEdit from './operation-edit.vue'
// import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import * as operatorApi from '@/api/rnt/operator'
import * as pointApi from '@/api/rnt/point.js'
import * as orderApi from '@/api/rnt/order'
export default {
  components: {
    // DownOutlined,
    // ExclamationCircleOutlined
    // operationDetail,
    // operationEdit
  },
  data() {
    return {
      visibleLog: false,
      visibleOrder: false,
      visibleEndTime: false,
      visibleRefund: false,
      visibleBatteryCode: false,
      operatorList: [],
      pointList: [],
      dischargeList: [],
      labelCol: { md: { span: 6 }, sm: { span: 24 } },
      wrapperCol: { md: { span: 16 }, sm: { span: 24 } },
      showDetail: false,
      showEdit: false,
      current: null,
      form: {},
      rules: {},
      expand: false,
      isShowOperator: false,
      columns: [
        {
          title: '序号',
          width: 48,
          // align: 'center',
          customRender: ({ text, record, index }) => index + 1
        },
        {
          title: '订单号',
          dataIndex: 'orderNumber'
        },
        {
          title: '到期时间',
          // width: 175,
          // align: 'center',
          dataIndex: 'endTime'
        },
        {
          title: '逾期天数',
          // width: 175,
          // align: 'center',
          dataIndex: 'overdueDay'
        },
        {
          title: '电池编号',
          // width: 90,
          // align: 'center',
          dataIndex: 'batteryCode'
        },
        {
          title: '放电开关',
          // width: 175,
          // align: 'center',
          dataIndex: 'electricSwitch'
        },
        {
          title: '手机号',
          // width: 85,
          // align: 'center',
          dataIndex: 'username'
        },
        {
          title: '真实姓名',
          // width: 85,
          // align: 'center',
          dataIndex: 'realName'
        },
        {
          // width: 175,
          // align: 'center',
          // dataIndex: 'operatorName',
          slots: {
            title: 'customTitle',
            customRender: 'operatorCustom'
          }
        },
        {
          title: '所属租赁点',
          // width: 175,
          // align: 'center',
          dataIndex: 'pointName'
        }
        // {
        //   title: '操作',
        //   width: 200,
        //   dataIndex: 'action',
        //   align: 'center',
        //   slots: {
        //     customRender: 'action'
        //   }
        // }
      ]
      // data: [
      //   {
      //     orderCode: 'Ord21122200064',
      //     orderState: '租赁中',
      //     phoneNumber: '18370082684',
      //     realName: '曾嘉文',
      //     batteryCode: 'BT307206012YDNO210905398',
      //     lateDay: '2',
      //     electricSwitch: '开启',
      //     operator: '厦门远丞科技有限公司',
      //     point: '明发2',
      //     endTime: '2022-01-11 09:45:36'
      //   },
      //   {
      //     orderCode: 'Ord21122200065',
      //     orderState: '租赁中',
      //     phoneNumber: '18370082684',
      //     realName: '曾嘉文',
      //     batteryCode: 'BT307206012YDNO210905398',
      //     lateDay: '2',
      //     electricSwitch: '开启',
      //     operator: '厦门远丞科技有限公司',
      //     point: '明发2',
      //     endTime: '2022-01-11 09:45:36'
      //   },
      //   {
      //     orderCode: 'Ord21122200066',
      //     orderState: '租赁中',
      //     phoneNumber: '18370082684',
      //     realName: '曾嘉文',
      //     batteryCode: 'BT307206012YDNO210905398',
      //     lateDay: '2',
      //     electricSwitch: '开启',
      //     operator: '厦门远丞科技有限公司',
      //     point: '明发2',
      //     endTime: '2022-01-11 09:45:36'
      //   },
      //   {
      //     orderCode: 'Ord21122200067',
      //     orderState: '租赁中',
      //     phoneNumber: '18370082684',
      //     realName: '曾嘉文',
      //     batteryCode: 'BT307206012YDNO210905398',
      //     lateDay: '2',
      //     electricSwitch: '开启',
      //     operator: '厦门远丞科技有限公司',
      //     point: '明发2',
      //     endTime: '2022-01-11 09:45:36'
      //   }
      // ]
    }
  },
  mounted() {
    this.queryPoint()
    this.queryOperater()
    this.queryDischarge()
  },
  methods: {
    // 条件表单运营商改变
    handleChangeOperator(value) {
      this.form.pointId = null
      pointApi
        .page({ operatorId: value })
        .then((res) => {
          if (res.code === 0) {
            this.pointList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询放电开关 */
    queryDischarge() {
      orderApi
        .dictData({ dictCode: 'dischargeSwitch' })
        .then((res) => {
          if (res.code === 0) {
            this.dischargeList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询所属租赁点 */
    queryPoint() {
      pointApi
        .page()
        .then((res) => {
          if (res.code === 0) {
            this.pointList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    /* 查询运营商 */
    queryOperater() {
      operatorApi
        .page()
        .then((res) => {
          if (res.code === 0) {
            this.operatorList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    // 获取表格数据
    datasource(option, callback) {
      orderApi
        .overdue({
          ...this.form,
          page: option.page,
          limit: option.limit,
          sort: 'overdueDay',
          order: 'asc'
        })
        .then((res) => {
          if (res.code === 0) {
            callback(res.data, res.count)
          } else {
            callback(res.msg)
          }
        })
        .catch((e) => {
          callback(e.message)
        })
    },
    openDetail(row) {
      this.current = row
      this.showDetail = true
    },
    openEdit(row) {
      this.current = row
      this.showEdit = true
    },
    // 新增计费模板确定按钮回调事件
    handleBillingOk() {
      this.$refs.billingForm.validate().then((res) => {
        console.log(res)
        this.$message.success('添加计费模板成功！')
        this.visible = false
      })
    },
    /* 刷新表格 */
    reload() {
      this.selection = []
      this.$refs.table.reload({ page: 1 })
    },
    /* 重置搜索 */
    reset() {
      this.form = {}
      this.queryPoint()
      this.$nextTick(() => {
        this.reload()
      })
    },
    // 是否展开表单
    expandForm() {
      this.expand = !this.expand
    },
    // 表格改变
    handleChange() { }
  }
}
</script>
<style lang='less' scoped>
.form {
  .btn-wrap {
    padding-right: 20px;

    .iconfont {
      margin-right: 5px;
    }
  }
}

.table {
  margin: 10px 0;
}
</style>
